/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreeTextAnswer
 */
export interface FreeTextAnswer {
    /**
     * 
     * @type {number}
     * @memberof FreeTextAnswer
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FreeTextAnswer
     */
    correctAnswer: string;
    /**
     * 
     * @type {number}
     * @memberof FreeTextAnswer
     */
    question: number;
}

/**
 * Check if a given object implements the FreeTextAnswer interface.
 */
export function instanceOfFreeTextAnswer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "correctAnswer" in value;
    isInstance = isInstance && "question" in value;

    return isInstance;
}

export function FreeTextAnswerFromJSON(json: any): FreeTextAnswer {
    return FreeTextAnswerFromJSONTyped(json, false);
}

export function FreeTextAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeTextAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'correctAnswer': json['correct_answer'],
        'question': json['question'],
    };
}

export function FreeTextAnswerToJSON(value?: FreeTextAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'correct_answer': value.correctAnswer,
        'question': value.question,
    };
}

